<template>
	<div class="homes">
		<div class="tops"></div>		
		<ul>
			<li class="items">
				<router-link to="warehousing">
					<img src="../assets/bottle_incoming.png" alt="">
					<span>气瓶入库</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="outbound">
					<img src="../assets/bottle_outcoming.png" alt="">
					<span>气瓶出库</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="bottle_apply">
					<img src="../assets/bottle_borrow.png" alt="">
					<span>气瓶领用</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="bottle_return">
					<img src="../assets/bottle_return.png" alt="">
					<span>气瓶归还</span>
				</router-link>
			</li>		
			<li class="items">
				<router-link to="audit">
					<img src="../assets/bottle_audit.png" alt="">
					<span>审核</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="stock">
					<img src="../assets/bottle_stat.png" alt="">
					<span>汇总查询</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="warning">
					<img src="../assets/borrow_overdue.png" alt="">
					<span>领用超期</span>
				</router-link>
			</li>
			<li class="items">
				<router-link to="earlyWarn">
					<img src="../assets/detect_overdue.png" alt="">
					<span>检测预警</span>
				</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
	import { checkAuthority } from "@/apis/api";
	export default {
		data() {
			return {

			}
		},
		mounted() {
			document.title = '预约系统'
			// 内部人士权限校验
			checkAuthority({}).then(res => {
				if (res.code === 200) {
					
				}
			});
		},
		beforeDestroy() {

		},
		methods: {

		}
	}
</script>
<style scoped lang="less">
	.homes{
		background: #F7F7F7;
		height: 100%;
	}
	.tops{
		background:url(../assets/banner.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 430px;
	}
	ul {
		display: flex;
		align-items: center;
		flex-direction: row;
		flex-wrap: wrap;
		padding-left: 40px;
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			width:325px;
			text-align: center;
			background: #ffffff;
			border-radius: 10px;
			margin-bottom:20px;
			padding: 20px 0;
			a{
				width: 100%;
				height: 100%;
				// display: inline-block;
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
			&:nth-child(2n+1){
				margin-right: 20px;
			}
			img{
				width: 120px;
				height: 120px;
				display: inline-block;
				margin: 0 auto;
			}
			span{
				font-size: 32px;
				font-weight: bold;
				margin-top: 20px;
				color: #666;
			}
		}
	}
	a:-webkit-any-link:active{
		color: #666;
	}
</style>
